import React, { Component } from 'react';
import { getUtterance } from '../../../services/API';
import * as Sentry from '@sentry/browser';
import {logSessionInfo} from '../../../services/logger';
import { logSentryException } from '../../../services/util';

export default class LexaSpeech extends Component {
  constructor(props) {
    super(props);

    this.state = {
      speech_marks: null,
      speech_audio: null,
      speechProps: {
        onStart: null,
        onEnd: null,
        onBoundary: null,
        textToSpeak: null,
      },
      speaking: false,
      audioURL: null,
      onFinishedPlaying: this.onUtteranceEnd.bind(this),
      speechVolume: 50,
    }
  }

    //This is where we handle a new speech request
  componentDidUpdate(prevprops){

    //If nothing we care about has changed or if we don't have speech properties, exit
    if( (prevprops.speechProps == this.props.speechProps) || (this.props.speechProps == null)){
      return;
    }

    // If the caller wants a word-by-word readback, then we use internal
    // otherwise let the avatar speak. Also have an override because Sumerian
    // eats speech marks at this point so if we need to control it, need to speak internally.
    let inText = this.props.speechProps.textToSpeak;
    if(inText !== null){
      //Invoke the text to speech API
      const includeSpeechMarks = !!this.props.speechProps.returnSpeechMarks;
      const locale = this.props.speechProps.locale
      getUtterance(inText, includeSpeechMarks, locale, 10000)
        .then(resp => {
          //This is where we send stuff to the avatar
          this.setState({
            speechProps: this.props.speechProps
          });
          this.props.sendToAvatar({
            ...this.props.speechProps,
            onStart: this.onUtteranceStart.bind(this),
            onEnd: this.onUtteranceEnd.bind(this),
            onBoundary: this.onWordEnd.bind(this),
            id: resp.id,
            audioURL: resp.audioURL,
            speech_marks: resp.speech_marks,
          });
      })
      .catch(err => {
        console.log('Could not get Utterance: ',err);
        logSentryException(err, "Could not get Utterance");
        logSessionInfo("speech_retries_exhausted",inText);
        this.setState({
          speechProps: this.props.speechProps,
        },()=>{
          this.onUtteranceStart(); 
          this.onUtteranceEnd();
        });
      });
    }
  }

  onWordEnd(word){
    if(this.state.speechProps && this.state.speechProps.onBoundary){
      this.state.speechProps.onBoundary(word);
    }
  }

  onUtteranceEnd(){
    //generate a callback function for this phrase
    // this is necessary to preserve the speech props after resetting the state
    function getOnEndCallback(speechProps){
      return function(){
        if(speechProps && speechProps.onEnd){
          speechProps.onEnd();
        }
      }
    }

    //Clear state for the next pass
    this.setState({
      speech_marks: null,
      speech_audio: null,
      speechProps: null,
      speaking: false,
      audioURL: null,
      speech_words: null,
      onFinishedPlaying: this.onUtteranceEnd,
    }, getOnEndCallback(this.state.speechProps).bind(this));
  }

  onUtteranceStart(){
    if(this.state.speechProps && this.state.speechProps.onStart){
      this.state.speechProps.onStart();
    }
  }

  render() {
   return null;
  }
}